/*
*
* KitStart Api
*
* @version 1.0.0
* @author Giorgia Cuozzo
* @since 17-Mar-2025
*/

import { axiosInstance as axios } from 'Api'
import { handlingResponse } from 'Utility/globalMethods'
import * as micropaymentsApi from 'Api/micropagamenti/micropagamenti'
import * as paymailApi from 'Api/payByLink/payByLink'
import * as backupPosApi from 'Api/backupPos/backupPos'
import * as softPosApi from 'Api/softPos/softPos'

if (process.env.ISMOCK === 'true') {
  try {
    require('Mocks/kitStart/kitStart')
  } catch (error) {
    console.error('Error loading info mock:', error)
  }
}

export async function startKitStart (params) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: 'services/marketing-service/public/kitstart/activation?fromKitStart=true',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function submitKitStart (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: 'services/marketing-service/public/kitstart/submit',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

// NEW: Use existing APIs for individual services
export async function getMicropaymentsShops (params) {
  return micropaymentsApi.getShops(params)
}

export async function getPaymailShops (params) {
  return paymailApi.getShops('NOT_ACTIVE', params)
}

export async function getSoftPosShops (params) {
  // BACKUP_POS
  return backupPosApi.getShopsList(params)
}

export async function getSoftPosShopsIsp (params) {
  // SOFT_POS
  return softPosApi.getShopsList(params)
}

// DEPRECATED: Keep for backward compatibility during transition
export async function kitStartStore (params) {
  console.warn('kitStartStore is deprecated. Use submitKitStart instead.')
  return submitKitStart(params)
}
// @generator api:method
